var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11328 7C1.11328 4.172 1.11328 2.757 1.99228 1.879C2.87028 1 4.28528 1 7.11328 1H11.1133C13.9413 1 15.3563 1 16.2343 1.879C17.1133 2.757 17.1133 4.172 17.1133 7V13.828C17.1133 16.511 17.1133 17.852 16.2693 18.263C15.4243 18.673 14.3693 17.844 12.2593 16.187L11.5843 15.656C10.3983 14.724 9.80428 14.258 9.11328 14.258C8.42228 14.258 7.82828 14.724 6.64228 15.656L5.96628 16.186C3.85628 17.844 2.80228 18.673 1.95728 18.263C1.11328 17.853 1.11328 16.51 1.11328 13.828V7Z",
    fill: "#FF6239",
    fillOpacity: 0.25,
    stroke: "#FF6239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkicon);
export default __webpack_public_path__ + "static/media/bookmarkicon.3212b1fe58e01bbaf3202784b5cd94bf.svg";
export { ForwardRef as ReactComponent };